import page from '../utils/rbata.page';
import Breakpoints from 'breakpoints-js/src/breakpoints';
import parallax from '../utils/rbata.parallax';

const storyListing = {
    storyListingWrapper:    undefined,
    filter:                 undefined,
    $body:                  undefined,
    filterItems:            [],
    mouseEnterHoverTimeout: undefined,
    mouseLeaveHoverTimeout: undefined,
    init() {
        this.storyListingWrapper = $('.stories-list');
        this.filter = this.storyListingWrapper.find('.stories-list__filters');
        this.stories = this.storyListingWrapper.find('.stories-list__column');
        this.$body = $('body');
        this.bindEvents();
    },

    bindEvents() {
        if (this.storyListingWrapper.length) {
            /**
             * Handles visibility of the filter options
             */
            this.storyListingWrapper.on('click', '.js-facet-clear-story', storyListing.clearAllFilters);
        }

        /**
         * Detect filter changes
         */
        this.storyListingWrapper.on('change', 'input[type="checkbox"]', function () {
            storyListing.storyListingWrapper.find('.js-apply-facet-selection-story').removeClass('d-none');
            storyListing.mirrorChoice($(this))
        });

        /**
         * Apply filters
         */
        this.storyListingWrapper.on('click', '.js-apply-facet-selection-story', this.prepareFiltering);

        /**
         * Mobile filter flyout trigger
         */
        this.storyListingWrapper.on('click', '.stories-list__filter--mobile-trigger', this.mobileFlyoutVisibility);

        /**
         * Mobile filtering - categories accordion
         */
        this.storyListingWrapper.on('click', '.stories-list__filter-category-dropdown', this.mobileDropdownAction);

        /**
         * Hide flyout
         */
        this.storyListingWrapper.on('click', '.js-close-stl-facet-overlay', () => this.mobileFlyoutVisibility(false));

        Breakpoints.on('desktop', {
            enter: () => {
                this.mobileFlyoutVisibility(false);
                this.adjustDescription(180);
            }
        }).on('tablet', {
            enter: () => {
                this.adjustDescription(110);
            }
        }).on('mobile', {
            enter: () => {
                this.adjustDescription(80);
            }
        });

        this.storyListingWrapper
            .on('mouseenter', '.stories-list__filter-wrapper', function () {
                storyListing.mouseEnterHoverTimeout = setTimeout(() => {
                    $(this).removeClass('hide');
                }, 350);

                if (storyListing.mouseLeaveHoverTimeout) {
                    clearTimeout(storyListing.mouseLeaveHoverTimeout);
                    storyListing.mouseLeaveHoverTimeout = undefined;
                }
            })
            .on('mouseleave', '.stories-list__filter-wrapper', function () {
                storyListing.mouseLeaveHoverTimeout = setTimeout(() => {
                    $(this).addClass('hide');
                }, 350);

                if (storyListing.mouseEnterHoverTimeout) {
                    clearTimeout(storyListing.mouseEnterHoverTimeout);
                    storyListing.mouseEnterHoverTimeout = undefined;
                }
            });
    },

    adjustDescription(length) {
        const $storyText = $('.stories-list__story-text');
        $.each($storyText, (index, element) => {
            const $elem = $(element);
            $elem.text(`${$elem.data('text').substr(0, length)}...`);
        });
    },

    clearAllFilters(evt) {
        evt.stopPropagation();
        storyListing.filterItems = [];
        storyListing.storyListingWrapper.find('input[type=checkbox]').prop('checked', false);
        storyListing.storyListingWrapper.find('.js-apply-facet-selection-story').addClass('d-none');
        storyListing.filterStories();
    },

    prepareFiltering() {
        const $this = $(this)
        const $rootParent = $this.parents('.stories-list');
        storyListing.filterItems = [];
        $.each($rootParent.find('.stories-list__filter--desktop input[type="checkbox"]:checked'), function (index, checkbox) {
            storyListing.filterItems.push($(checkbox).val());
        });
        storyListing.filterStories();
        $('.js-apply-facet-selection-story').addClass('d-none');
        storyListing.mobileFlyoutVisibility(false);
        parallax.onScrollAndLoad();
    },

    filterStories() {
        if (storyListing.filterItems.length) {
            storyListing.stories.addClass('d-none');
            $.each(storyListing.filterItems, (index, item) => {
                storyListing.stories
                            .find(`.stories-list__category[data-story-category="${item}"]`)
                            .parents('.stories-list__column').removeClass('d-none');
            });
        } else {
            storyListing.stories.removeClass('d-none');
        }
        /**
         * Update filter counter
         */
        storyListing.filter
                    .parents('.stories-list')
                    .find('.stories-list__filter-counter')
                    .html(storyListing.filterItems.length === 0 ? '' : storyListing.filterItems.length);

        storyListing.filterItems.length > 0 ?
                storyListing.storyListingWrapper.find('.js-facet-clear-story').removeClass('d-none') :
                storyListing.storyListingWrapper.find('.js-facet-clear-story').addClass('d-none');
    },

    mobileFlyoutVisibility(visible = true) {
        const $flyout = storyListing.storyListingWrapper.find('.stories-list__filter-flyout');
        const $dropdown = storyListing.storyListingWrapper.find('.stories-list__filter-category-dropdown');

        if (visible) {
            $flyout.addClass('facet__overlay--visible');
            page.addBackdrop(true, storyListing.$body);
        } else {
            $flyout.removeClass('facet__overlay--visible');
            $dropdown.removeClass('active')
                     .siblings('.stories-list__filter-options')
                     .toggleClass('d-none');
            page.addBackdrop(false, storyListing.$body);
        }
    },

    mobileDropdownAction() {
        const $this = $(this);
        $this.toggleClass('active');
        $this.siblings('.stories-list__filter-options')
             .toggleClass('d-none');
    },

    /**
     * Sync overlay and desktop filter checkboxes
     * @param currentCheckbox
     */
    mirrorChoice(currentCheckbox) {
        currentCheckbox.parents('.stories-list')
                       .find(`input[value="${currentCheckbox.val()}"]`)
                       .prop('checked', currentCheckbox.is(':checked'));
    }
}

$(() => {
    if ($('.stories-list').length) {
        storyListing.init();
    }
});

export default storyListing;
